/**
 * Recursively removes nav "section"/"collapsible" nodes that have no renderable children.
 * This prevents rendering empty section headers, dividers, and spacing gaps.
 *
 * Important: We DO NOT change any upstream business logic (permissions/flags/routes).
 * We only prune nodes that would result in no visible items.
 */
export function pruneNavItems(items) {
  if (!Array.isArray(items) || items.length === 0) return [];

  const pruned = [];

  for (const item of items) {
    if (!item || typeof item !== "object") continue;

    const type = item.type;
    if (type === "nav-item") {
      // Consider it renderable if it has at least a label+uri; otherwise ignore it.
      if (item.label && item.uri) pruned.push(item);
      continue;
    }

    if (type === "section" || type === "collapsible") {
      const children = pruneNavItems(item.children);
      if (children.length === 0) continue;

      // If a "section" only contains other sections, it would render a header with
      // no actual clickable entries underneath (only more headers). In that case,
      // flatten it to avoid empty-looking wrapper sections like "Ostatné".
      if (
        type === "section" &&
        children.every((c) => c?.type === "section")
      ) {
        pruned.push(...children);
        continue;
      }

      pruned.push({ ...item, children });
      continue;
    }

    // Unknown item types are not renderable; drop them.
  }

  return pruned;
}

